/* eslint-disable */


import Swiper, {
  Navigation,
  Keyboard,
} from 'swiper';

import Lottie from 'lottie-web';

import Cookies from 'js-cookie';


import trapFocus from './trapfocus';


export default function interactivemap() {

  const langu = document.documentElement.lang;
  if (langu === "fr-FR") {
    $('.container-facile').hide();
  }
  if (langu === "en-GB") {
    $('.container-facile').hide();
  }

  let words = [];

  function addClassToTerms(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var text = node.textContent;
      words.forEach(function(word) {
        var regex = new RegExp('\\b' + word.term + '\\b', 'gi');
        text = text.replace(regex, '<span class="underlinelf">$&</span>');
      });
      var tempElement = document.createElement('div');
      tempElement.innerHTML = text;
      while (tempElement.firstChild) {
        node.parentNode.insertBefore(tempElement.firstChild, node);
      }
      node.parentNode.removeChild(node);
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      node.childNodes.forEach(addClassToTerms);
    }
  }
  

  
  let activePopover = null;
  let activeWord = null;
  
  function handleWordInteraction(event) {
    // Check if the event is from a word that should show or hide the popover
    if (event.target.classList.contains('underlinelf')) {
      var clickedWord = event.target.textContent;
      var wordTitle = '';
  
      words.forEach(function(word) {
        if (word.term.toLowerCase() === clickedWord.toLowerCase()) {
          wordTitle = word.title;
        }
      });
  
      // Toggle the popover if it's already open for this word
      if (activePopover && activeWord === clickedWord) {
        document.body.removeChild(activePopover);
        activePopover = null;
        activeWord = null;
      } else {
        // Remove existing popover if any
        if (activePopover) {
          document.body.removeChild(activePopover);
        }
  
        // Show new popover
        if (wordTitle !== '') {
          var popover = document.createElement('div');
          popover.classList.add('popover');
          popover.innerHTML = wordTitle;
  
          document.body.appendChild(popover);
          activePopover = popover;
          activeWord = clickedWord;
  
          // Optional: Position the popover
        }
  
        // Close popover on click elsewhere
        function handleClickOutside(event) {
          if (popover && (!popover.contains(event.target) && !event.target.classList.contains('underlinelf'))) {
            document.body.removeChild(popover);
            activePopover = null;
            activeWord = null;
            document.removeEventListener('click', handleClickOutside);
          }
        }
  
        // Add the listener with a delay
        setTimeout(() => {
          document.addEventListener('click', handleClickOutside);
        }, 0);
      }
    }
  }
  
  
  function attachInteractionListenersToBody() {
    document.body.addEventListener('click', handleWordInteraction, true);

  }
    

  const infoboxWrapper = $('.infobox__wrapper');
  const placeIcon = $('.place--icon');
  const place = $('.place');
  const infobox = $('.infobox');
  const blackfiltermap = $('.blackfiltermap');
  const closeDiv = $('.close-div');
  const loading = $('.loading');
  var toggle = document.getElementById('toggle');



  $('.seeMoreBtn').on('click', function() {
    $('.container-facile').toggleClass('bottom-contain');
  });


  $('.container-facile-btn').on('click', function() {
    if ($(this).hasClass('activelf')) {
      $('.infobox').removeClass('bigFont');
      $(this).removeClass('activelf');
      toggle.checked = !toggle.checked;
      $('.lang-item-lu').show();  
      $('.lang-item-en').show();      
      $('.lang-item-fr').show();    
    } else {
      $(this).addClass('activelf');
        $('.lang-item-lu').hide();  
        $('.lang-item-en').hide();     
        $('.lang-item-fr').hide();       
      toggle.checked = !toggle.checked;
      $('.infobox').addClass('bigFont');
    }
});

  var hostname = window.location.origin

  console.log(Lottie);

  let cookiepopup = (Cookies.get('popupactive'));

  if (cookiepopup == 'hide') {
    $('.popup').addClass('hidepopup');
  } else {
    $('.blackfiltermap').show();
    $('.popup').addClass('showpopup');
    $('.popup button').focus();
  }

  $('.menu-button').on('click', function() {
      $('.menu-allplaces').toggleClass('close-allplaces');
      $('.menu-allplaces').toggleClass('open-allplaces');
      $('.menu-button').fadeOut('slow');
  });

  $('.menu-button-close').on('click', function() {
    $('.menu-allplaces').toggleClass('close-allplaces');
    $('.menu-allplaces').toggleClass('open-allplaces');
    $('.menu-button').show();
});

  $('.one-station').on('click', function() {
    let stationidmenu = $(this).attr('data-id');
    $('.name' + stationidmenu + '').trigger('click');
});



  if (hostname == 'https://cinqfontaines.lu') {
    $('.place').on('click', function() {
      if ($(this).hasClass('activepin')) {
        loading.show();
        placeIcon.attr('fill', '#E3000B');
        infobox.removeClass('open');
        blackfiltermap.hide();
        closeDiv.hide();
        place.removeClass('activepin');

        infoboxWrapper.removeClass('overflow').attr('aria-expanded', false)
            .removeClass('show');

        setTimeout(() => infoboxWrapper.removeClass('show'), 500);
       } else {
        let placeid = $(this).attr('id');
        let image = $(this).attr('data-img')
        let title = $(this).attr('data-title')
        let date = $(this).attr('data-date')
        $('.loading').show();
        $('.place--icon').attr('fill', '#E3000B');
        $('.place').removeClass('activepin');
        $('.infobox').addClass('open');
        $('.close-div').hide();
        $('.block-json').remove();
        $('.blackfiltermap').show();
        $('.place--icon').attr('fill', '#979797');
        $(this).find('.place--icon').attr('fill', '#E3000B')
        $(this).addClass('activepin');
        $('.infobox__wrapper').removeClass('overflow');
        $('.infobox__wrapper').addClass('show');
        const lang = document.documentElement.lang;
        if(lang === "fr-FR") {
          $.getJSON('https://cinqfontaines.lu/wp-json/wp/v2/glossar/1247', function(data) {
            words = [];
            const glossar = data.acf.glossar;
            glossar.forEach(item => {
              words.push({
                  term: item.term, 
                  title: item.title
              });
          });
          console.table(words)
          });
      } 
      else if(lang === "de-DE") {
        $.getJSON('https://cinqfontaines.lu/wp-json/wp/v2/glossar/1246', function(data) {
          words = [];
          const glossar = data.acf.glossar;
          glossar.forEach(item => {
            words.push({
                term: item.term, 
                title: item.title
            });
        });
        });
      }
        $.when($.getJSON('https://cinqfontaines.lu/wp-json/wp/v2/cqf_places/' + placeid, function(result) {
            $('.infobox__wrapper--headerimage').attr('src', image);
            $('.place-title').text(title);
            $('.place-date').text(date);
            $('.infobox__wrapper').append(result.content.rendered);
            loadswiper();
          })).then(function() {
            if ($('.container-facile-btn').hasClass('activelf')) {
              $('.notlf').hide();
              addClassToTerms(document.body);
              attachInteractionListenersToBody();
            } else {
              $('.lftext').hide();
            }
            const mapInfoBox = document.querySelector('.infobox');
            if(mapInfoBox){
              trapFocus(mapInfoBox, mapInfoBox, 'open');
            }
            $('.infobox__wrapper').attr('aria-expanded', true);
            $('.infobox__wrapper').trigger('focus');
            $('.infobox__wrapper').scrollTop(0);

            $('.infobox__wrapper').addClass('overflow');
            $('.loading').hide();
            $('.close-div').show(100);
        })
       }
  });
  } else {
    $('.place').on('click', function() {
      if ($(this).hasClass('activepin')) {
        loading.show();
        placeIcon.attr('fill', '#E3000B');
        infobox.removeClass('open');
        blackfiltermap.hide();
        closeDiv.hide();
        place.removeClass('activepin');

        infoboxWrapper.removeClass('overflow').attr('aria-expanded', false)
            .removeClass('show');

        setTimeout(() => infoboxWrapper.removeClass('show'), 500);
       } else {
        let placeid = $(this).attr('id');
        let image = $(this).attr('data-img')
        let title = $(this).attr('data-title')
        let date = $(this).attr('data-date')
        $('.loading').show();
        $('.place--icon').attr('fill', '#E3000B');
        $('.place').removeClass('activepin');
        $('.infobox').addClass('open');
        $('.close-div').hide();
        $('.block-json').remove();
        $('.blackfiltermap').show();
        $('.place--icon').attr('fill', '#979797');
        $(this).find('.place--icon').attr('fill', '#E3000B')
        $(this).addClass('activepin');
        $('.infobox__wrapper').removeClass('overflow');
        $('.infobox__wrapper').addClass('show');
        const lang = document.documentElement.lang;
        if(lang === "fr-FR") {
          $.getJSON('https://cinqfontaines.l0la.lu/wp-json/wp/v2/glossar/1207', function(data) {
            words = [];
            const glossar = data.acf.glossar;
            glossar.forEach(item => {
              words.push({
                  term: item.term, 
                  title: item.title
              });
          });
          console.table(words)
          });
      } 
      else if(lang === "de-DE") {
        $.getJSON('https://cinqfontaines.l0la.lu/wp-json/wp/v2/glossar/1208', function(data) {
          words = [];
          const glossar = data.acf.glossar;
          glossar.forEach(item => {
            words.push({
                term: item.term, 
                title: item.title
            });
        });
        });
      }
        $.when($.getJSON('https://cinqfontaines.l0la.lu/wp-json/wp/v2/cqf_places/' + placeid, function(result) {
            $('.infobox__wrapper--headerimage').attr('src', image);
            $('.place-title').text(title);
            $('.place-date').text(date);
            $('.infobox__wrapper').append(result.content.rendered);
            loadswiper();
          })).then(function() {
            if ($('.container-facile-btn').hasClass('activelf')) {
              $('.notlf').hide();
              addClassToTerms(document.body);
              attachInteractionListenersToBody();
            } else {
              $('.lftext').hide();
            }
            const mapInfoBox = document.querySelector('.infobox');
            if(mapInfoBox){
              trapFocus(mapInfoBox, mapInfoBox, 'open');
            }
            $('.infobox__wrapper').attr('aria-expanded', true);
            $('.infobox__wrapper').trigger('focus');
            $('.infobox__wrapper').scrollTop(0);

            $('.infobox__wrapper').addClass('overflow');
            $('.loading').hide();
            $('.close-div').show(100);
        })
       }
  });
  }



  function loadswiper() {
    Swiper.use([Navigation, Keyboard]);
    var swiper = new Swiper('.mySwiper', {
       autoHeight: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
    });
    console.log(swiper);
}

Swiper.use([Navigation, Keyboard]);
var swiper = new Swiper('.mySwiper', {
   autoHeight: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
});
console.log(swiper);


  $('.closepopupbtn').on('click', function() {
    $('.loading').show();
    $('.place--icon').attr('fill', '#E3000B');
    $('.place').removeClass('activepin');
    $('.infobox').removeClass('open');
    $('.blackfiltermap').hide();
    $('.close-div').hide();
    $('.infobox__wrapper').removeClass('overflow');
    Cookies.set('popupactive', 'hide', { expires: 365 })
    $('.popup').hide();
    $('.popup').removeClass('showpopup');
    });

  // Close popup with ESC key
  $('.popup').on('keyup', function(e) {
    if(e.key == 'Escape'){
      $('.loading').show();
      $('.place--icon').attr('fill', '#E3000B');
      $('.place').removeClass('activepin');
      $('.infobox').removeClass('open');
      $('.blackfiltermap').hide();
      $('.close-div').hide();
      $('.infobox__wrapper').removeClass('overflow');
      Cookies.set('popupactive', 'hide', { expires: 365 })
      $('.popup').hide();
      $('.popup').removeClass('showpopup');
    }
  });



}



// WEBPACK FOOTER //
// ./scripts/modules/interactivemap.js